import { Settings2, Users, Building2 } from "lucide-react";
import { PageTitle } from "@/components/PageHeader";
import { Link } from "react-router-dom";
import { useDash } from "./ctx";
import { CompanyBrandCard } from "@/components/CompanyBrandCard";
import { PortfolioReportCard } from "@/components/PortfolioReportCard";
import { CompanySelfManagedCard } from "@/components/CompanySelfManagedCard";

// Portfolio settings — the management company's own configuration (brand today; more to come).
export default function PortfolioSettings() {
  const { viewCompanyId, meUser } = useDash();
  const isRedline = ["super_admin", "platform_admin"].includes(meUser?.role);
  // Only company seats (or a super admin viewing a firm) have a portfolio to configure — a
  // community manager also carries company_id, but this page isn't theirs.
  const companySeat = ["company_admin", "regional_manager"].includes(meUser?.role);
  const companyId = viewCompanyId || (companySeat ? meUser?.company_id : null) || null;
  if (!companyId) {
    return <div className="text-sm text-muted-foreground p-6" data-testid="portfolio-settings-none">No portfolio selected — portfolio settings belong to the management company's administrators.</div>;
  }
  return (
    <div className="space-y-6" data-testid="portfolio-settings-page">
      <div>
        <PageTitle title={<><Settings2 className="h-7 w-7 text-redline-500" strokeWidth={1.75} /> Portfolio settings</>} about="How your firm shows up across the portfolio console. Community-level settings live inside each community." />
      </div>
      {isRedline && <CompanySelfManagedCard companyId={companyId} />}
      <CompanyBrandCard companyId={companyId} />
      <PortfolioReportCard companyId={companyId} />
      <div className="grid gap-3 sm:grid-cols-2">
        <Link to="/dashboard/team" data-testid="portfolio-settings-team" className="rounded-2xl border border-sand-200 bg-white p-4 flex items-start gap-3 hover:border-ink transition-colors">
          <span className="h-9 w-9 rounded-xl bg-sand-100 flex items-center justify-center shrink-0"><Users className="h-[18px] w-[18px]" strokeWidth={1.5} /></span>
          <span><span className="block font-semibold text-sm">Team & access</span><span className="block text-xs text-muted-foreground mt-0.5">Who works at the firm and which communities each community manager runs.</span></span>
        </Link>
        <Link to="/dashboard/portfolio-communities" data-testid="portfolio-settings-communities" className="rounded-2xl border border-sand-200 bg-white p-4 flex items-start gap-3 hover:border-ink transition-colors">
          <span className="h-9 w-9 rounded-xl bg-sand-100 flex items-center justify-center shrink-0"><Building2 className="h-[18px] w-[18px]" strokeWidth={1.5} /></span>
          <span><span className="block font-semibold text-sm">Communities</span><span className="block text-xs text-muted-foreground mt-0.5">Every community in the portfolio — open one to change its own brand, line and modules.</span></span>
        </Link>
      </div>
    </div>
  );
}
